import Immutable from 'immutable';

const LOAD_ALL = 'performanceScoreCard/LOAD_ALL';
const LOAD_ALL_SUCCESS = 'performanceScoreCard/LOAD_ALL_SUCCESS';
const LOAD_ALL_FAIL = 'performanceScoreCard/LOAD_ALL_FAIL';

const LOAD_ALL_PROVIDERS = 'performanceScoreCard/LOAD_ALL_PROVIDERS';
const LOAD_ALL_PROVIDERS_SUCCESS = 'performanceScoreCard/LOAD_ALL_PROVIDERS_SUCCESS';
const LOAD_ALL_PROVIDERS_FAIL = 'performanceScoreCard/LOAD_ALL_PROVIDERS_FAIL';

const SEND_REPORT = 'performanceScoreCard/SEND_REPORT';
const SEND_REPORT_SUCCESS = 'performanceScoreCard/SEND_REPORT_SUCCESS';
const SEND_REPORT_FAIL = 'performanceScoreCard/SEND_REPORT_FAIL';

const initialState = Immutable.fromJS({
  isLoad: false,
  allMetrics: null,
  loadErr: null,
  isLoadProviders: false,
  allProvidersData: null,
  loadProvidersErr: null,
  isSendingReport: false,
  sendReportErr: null,
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case LOAD_ALL:
      return state
        .set('isLoad', true)
        .set('loadErr', null);

    case LOAD_ALL_SUCCESS:
      return state
        .set('isLoad', false)
        .set('allMetrics', action.res)
        .set('loadErr', null);

    case LOAD_ALL_FAIL:
      return state
        .set('isLoad', false)
        .set('loadErr', action.error)
        .set('allMetrics', null);

    case LOAD_ALL_PROVIDERS:
      return state
        .set('isLoadProviders', true)
        .set('loadProvidersErr', null);

    case LOAD_ALL_PROVIDERS_SUCCESS:
      return state
        .set('isLoadProviders', false)
        .set('allProvidersData', action.res)
        .set('loadProvidersErr', null);

    case LOAD_ALL_PROVIDERS_FAIL:
      return state
        .set('isLoadProviders', false)
        .set('loadProvidersErr', action.error)
        .set('allProvidersData', null);

    case SEND_REPORT:
      return state
        .set('isSendingReport', true)
        .set('sendReportErr', null);

    case SEND_REPORT_SUCCESS:
      return state
        .set('isSendingReport', false);

    case SEND_REPORT_FAIL:
      return state
        .set('isSendingReport', false)
        .set('sendReportErr', action.error);

    default:
      return state;
  }
}

/**
 * Fetch performance metrics for a specific provider
 * Uses the byProvider endpoint which shares the same functionality as all-providers
 */
export const getAllMetrics = (params = {}) => async (dispatch, _getState, api) => {
  dispatch({ type: LOAD_ALL });
  try {
    const { dentist } = params;
    const queryParams = JSON.stringify({
      provider: dentist || null
    });

    const data = await api.get(`performanceScoreCard/byProvider/${queryParams}`);
    dispatch({ type: LOAD_ALL_SUCCESS, res: data });
    return data;
  } catch (err) {
    dispatch({ type: LOAD_ALL_FAIL, error: err.message });
    throw err;
  }
};

export const getAllProvidersMetrics = (params = {}) => async (dispatch, _getState, api) => {
  dispatch({ type: LOAD_ALL_PROVIDERS });
  try {
    const { udaRole, provider } = params;
    const queryParams = JSON.stringify({
      udaRole: udaRole || null,
      provider: provider || null
    });

    const data = await api.get(`performanceScoreCard/all-providers/${queryParams}`);
    dispatch({ type: LOAD_ALL_PROVIDERS_SUCCESS, res: data });
    return data;
  } catch (err) {
    dispatch({ type: LOAD_ALL_PROVIDERS_FAIL, error: err.message });
    throw err;
  }
};

export const getByMetricAndProvider = (params = {}) => async (dispatch, _getState, api) => {
  dispatch({ type: LOAD_ALL_PROVIDERS });
  try {
    const { udaRole, provider, metric } = params;
    const queryParams = JSON.stringify({
      udaRole: udaRole || null,
      provider: provider || null,
      metric: metric || null
    });

    const data = await api.get(`performanceScoreCard/by-metric-provider/${queryParams}`);
    dispatch({ type: LOAD_ALL_PROVIDERS_SUCCESS, res: data });
    return data;
  } catch (err) {
    dispatch({ type: LOAD_ALL_PROVIDERS_FAIL, error: err.message });
    throw err;
  }
};

export const getPracticeReviews = (params = {}) => async (_dispatch, _getState, api) => {
  try {
    const { provider } = params;
    const queryParams = JSON.stringify({
      provider: provider || null
    });
    return await api.get(`performanceScoreCard/get-practice-reviews/${queryParams}`);
  } catch (err) {
    console.log('Error fetching practice reviews:', err?.message || err);
    return { totalReviews: 0, target: 95 };
  }
};

export const getPracticeReviewsList = (params = {}) => async (_dispatch, _getState, api) => {
  try {
    const queryParams = JSON.stringify(params);
    return await api.get(`performanceScoreCard/get-practice-reviews-list/${queryParams}`);
  } catch (err) {
    console.log('Error fetching practice reviews list:', err?.message || err);
    return { reviewsList: [] };
  }
};

export const sendUserReport = (params = {}) => async (dispatch, _getState, api) => {
  dispatch({ type: SEND_REPORT });
  try {
    const data = await api.post('performanceScoreCard/send-report/user', { data: params });
    dispatch({ type: SEND_REPORT_SUCCESS, res: data });
    return data;
  } catch (err) {
    dispatch({ type: SEND_REPORT_FAIL, error: err.message });
    throw err;
  }
};

export const sendReport = (params = {}) => async (dispatch, _getState, api) => {
  dispatch({ type: SEND_REPORT });
  try {
    const data = await api.post('performanceScoreCard/send-report', { data: params });
    dispatch({ type: SEND_REPORT_SUCCESS, res: data });
    return data;
  } catch (err) {
    dispatch({ type: SEND_REPORT_FAIL, error: err.message });
    throw err;
  }
};

export const sendCareReport = (params = {}) => async (dispatch, _getState, api) => {
  dispatch({ type: SEND_REPORT });
  try {
    const data = await api.post('performanceScoreCard/send-care-report', { data: params });
    dispatch({ type: SEND_REPORT_SUCCESS, res: data });
    return data;
  } catch (err) {
    dispatch({ type: SEND_REPORT_FAIL, error: err.message });
    throw err;
  }
};

export const sendHygieneReport = (params = {}) => async (dispatch, _getState, api) => {
  dispatch({ type: SEND_REPORT });
  try {
    const data = await api.post('performanceScoreCard/send-hygiene-report', { data: params });
    dispatch({ type: SEND_REPORT_SUCCESS, res: data });
    return data;
  } catch (err) {
    dispatch({ type: SEND_REPORT_FAIL, error: err.message });
    throw err;
  }
};

export const sendShowRateReport = (params = {}) => async (dispatch, _getState, api) => {
  dispatch({ type: SEND_REPORT });
  try {
    const data = await api.post('performanceScoreCard/send-show-rate-report', { data: params });
    dispatch({ type: SEND_REPORT_SUCCESS, res: data });
    return data;
  } catch (err) {
    dispatch({ type: SEND_REPORT_FAIL, error: err.message });
    throw err;
  }
};

export const sendRecallRateReport = (params = {}) => async (dispatch, _getState, api) => {
  dispatch({ type: SEND_REPORT });
  try {
    const data = await api.post('performanceScoreCard/send-recall-rate-report', { data: params });
    dispatch({ type: SEND_REPORT_SUCCESS, res: data });
    return data;
  } catch (err) {
    dispatch({ type: SEND_REPORT_FAIL, error: err.message });
    throw err;
  }
};

export const sendFiveStarReviewEmail = (params = {}) => async (dispatch, _getState, api) => {
  dispatch({ type: SEND_REPORT });
  try {
    const data = await api.post('performanceScoreCard/send-five-star-review-report', { data: params });
    dispatch({ type: SEND_REPORT_SUCCESS, res: data });
    return data;
  } catch (err) {
    dispatch({ type: SEND_REPORT_FAIL, error: err.message });
    throw err;
  }
};

export const sendDaysWorkedReport = (params = {}) => async (dispatch, _getState, api) => {
  dispatch({ type: SEND_REPORT });
  try {
    const data = await api.post('performanceScoreCard/send-days-worked-report', { data: params });
    dispatch({ type: SEND_REPORT_SUCCESS, res: data });
    return data;
  } catch (err) {
    dispatch({ type: SEND_REPORT_FAIL, error: err.message });
    throw err;
  }
};

export const sendTreatmentPlanReport = (params = {}) => async (dispatch, _getState, api) => {
  dispatch({ type: SEND_REPORT });
  try {
    const data = await api.post('performanceScoreCard/send-treatment-plan-report', { data: params });
    dispatch({ type: SEND_REPORT_SUCCESS, res: data });
    return data;
  } catch (err) {
    dispatch({ type: SEND_REPORT_FAIL, error: err.message });
    throw err;
  }
};

export const updateSendPerformanceScore = (params = {}) => async (_dispatch, _getState, api) => {
  try {
    return await api.post('performanceScoreCard/update-send-performance-score', { data: params });
  } catch (err) {
    console.error('Error updating sendPerformanceScore:', err?.message || err);
    throw err;
  }
};


export const savePerformanceScoreSummaryEmail = (params = {}) => async (_dispatch, _getState, api) => {
  try {
    return await api.post('performanceScoreCard/save-performance-summary-email', {data:params});
  } catch (err) {
    console.error('Error updating sendPerformanceScore:', err?.message || err);
    throw err;
  }
};


export const getPerformanceScoreSummaryEmail = () => async (_dispatch, _getState, api) => {
  try {
    return await api.get('performanceScoreCard/performance-summary-email');
  } catch (err) {
    console.error('Error updating sendPerformanceScore:', err?.message || err);
    throw err;
  }
};


export const deletePerformanceScoreSummaryEmail = (params = {}) => async (_dispatch, _getState, api) => {
  try {
     return await api.post('performanceScoreCard/delete-performance-summary-email', {data:params});
  } catch (err) {
    console.error('Error updating sendPerformanceScore:', err?.message || err);
    throw err;
  }
};